import React from 'react';

// Dependencies
import Textarea from 'react-textarea-autosize';

class LimitTextarea extends React.Component {
  constructor() {
    super();
    this.calculate = this.calculate.bind(this);
    this.highlightClass = this.highlightClass.bind(this);
  }

  componentWillMount() {
    this.state = {
      remaining: null
    }
  }

  componentDidMount() {
    this.calculate();
  }

  calculate() {
    const _this = this;

    this.setState({
      remaining: this.props.limit - this.textarea.value.length
    }, function(){
      const textarea = document.querySelector(`#${_this.textarea.props.id}`);

      if(_this.state.remaining < 0) {
        textarea.setCustomValidity('invalid');
      } else {
        textarea.setCustomValidity('');
      }
    });
  }

  highlightClass() {
    let className = '';

    if(this.state.remaining <= 20 && this.state.remaining > 10) {
      className = 'notify';
    } else if(this.state.remaining <= 10 && this.state.remaining >= 0) {
      className = 'warn';
    } else if(this.state.remaining < 0) {
      className = 'error';
    }

    return className;
  }

  render() {
    return (
      <div className={this.props.wrapperClass || ''}>
        <Textarea
          id={this.props.id}
          className={`limit ${this.props.className}`}
          placeholder={this.props.placeholder}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onChange}
          onInput={this.calculate}
          ref={(input) => {this.textarea = input}}
          required={this.textarea && this.textarea.value.length > 0}
          aria-required={this.textarea && this.textarea.value.length > 0}
          disabled={this.props.disabled ? true : false}
        ></Textarea>

        {this.textarea && this.textarea.value &&
          <span
            className={`limit__left ${this.highlightClass()}`}
          >
            {this.state.remaining}
          </span>
        }
      </div>
    )
  }
}

export default LimitTextarea;



// WEBPACK FOOTER //
// ./src/app/components/Common/LimitTextarea.js